<div class="splash">
  <div class="card">
    <div class="icon">😕</div>
    <h1>Oops — something went wrong</h1>
    <p class="lead">We couldn't find this restaurant’s tenant configuration.</p>
    <p class="sub">If you think this is a mistake, please contact support.</p>

    <div class="actions">
      <button class="btn-primary" [disabled]="loading" (click)="retry()">
        @if (!loading) {
          Try again
        } @else {
          Trying…
        }
      </button>

      <a class="btn-outline" href="mailto:support@waitron.uk"
        >Contact support</a
        >
      </div>

      @if (error) {
        <p class="err">{{ error }}</p>
      }
    </div>
  </div>
